@import '../../styles/tokens';

:host {
  display: inline-block;
}

button {
  cursor: pointer;
  border: none;
  border-radius: 4px;
  font-family: inherit;
  font-weight: 500;
}


button.size-sm {
  padding: 3px 8px;
  font-size: 12px;
}

button.size-md {
  padding: 6px 12px;
  font-size: 14px;
}

button.size-lg {
  padding: 8px 16px;
  font-size: 16px;
}

/* Variants */
button.variant-flat {
  color: #ffffff;
}

button.variant-outlined {
  background-color: transparent;
  border: 2px solid currentColor;
}

/* Disabled */
button:disabled {
  cursor: not-allowed;
  pointer-events: none;
  color: var(--accent-400);
  background-color: var(--accent-200);
}
